export const standard = {
  today: '@standard.today'
}
